export const menuTitle = { title: "PRODUCT SIZE", label: "Product Size" }
  